import * as React from 'react';
import classnames from 'classnames';
import { useInView } from 'react-intersection-observer';
import { ResponsiveImage } from '@grandvisionhq/elements';

const LazyImage = ({ src , alt , className , width , height , rootMargin ='0px 0px' , srcSet , sizes , placeholder , isContained ,  })=>{
    if (!src || !width || !height) {
        console.warn('Width and height are required when using LazyImage');
        return null;
    }
    const [ref, inView] = useInView({
        rootMargin,
        triggerOnce: true
    });
    const renderImage = ()=>srcSet && sizes ? /*#__PURE__*/ React.createElement(ResponsiveImage, {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes,
            isContained: isContained
        }) : /*#__PURE__*/ React.createElement("img", {
            src: src,
            alt: alt,
            width: width,
            height: height
        })
    ;
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: classnames('lazy-image', className),
        style: {
            paddingBottom: `${height / width * 100}%`
        }
    }, inView ? renderImage() : placeholder || null);
};

export { LazyImage as default };
//# sourceMappingURL=LazyImage.js.map
